/**
 * @fileoverview Component for displaying an empty list of studies.
 * This component includes a message and an icon.
 */

import StudyIcon from '../../assets/menu/studies.svg'

/**
 * @function StudyListEmpty
 * @description Component for displaying an empty list of studies.
 * @returns {JSX.Element} - A React component that renders the empty list of studies.
 */
export function StudyListEmpty() {
    return (
        <div className="flex flex-col grow justify-center mt-32 px-8 py-8">
            <div className="flex self-center flex-col items-center">
                <div className="flex justify-center items-center w-16 h-16 rounded-full bg-indigo-50 mb-4">
                    <StudyIcon className="w-6 h-6 stroke-indigo-500 stroke-2" />
                </div>
                <h2 className="mb-3 text-gray-900 text-xl font-semibold">No studies to display</h2>
                <p className="text-base text-gray-600">
                    No matching studies or insufficient permissions to view.
                </p>
            </div>
        </div>
    )
}
